// extracted by mini-css-extract-plugin
module.exports = {"container":"code-insights_container__HL5oN","icon-subheader":"code-insights_icon-subheader__0iOtf","icon-paragraph":"code-insights_icon-paragraph__eAjr4"};